"use strict";
exports.__esModule = true;
exports.PREFERENCES = void 0;
var PREFERENCES = {
    CUSTOMER_COLOURS: {
        COLOR1: 'color1',
        COLOR2: 'color2',
        COLOR3: 'color3',
        COLOR4: 'color4',
        COLOR5: 'color5'
    }
};
exports.PREFERENCES = PREFERENCES;
